<template src="./media-thumb.html"></template>

<script lang="ts">
import { hostsConfig } from 'init/config'
import mediaMixin from './MediaMixin.vue'
import { getOrientationTransform } from 'util/media-utils'


export default {
  data() {
    return {
      height: 0,
      isImageLoaded: false,
      width: 0,
      // MediaThumb and MediaSubmissionThumb both use the same html file, this is used to
      // specify the lazy loading of the image, which in this case should always be false
      useLazy: false
    }
  },
  mixins: [mediaMixin],
  props: {
    altText: String,
    onlyUseSrc: Boolean
  },
  computed: {
    imageCssPropertyValues() {
      const dims = this.getPanAndZoomDimensions(this.width, this.height, this.size, this.size)
      const newWidth = dims.width
      const newHeight = dims.height
      // we may need to adjust the top or left to fit in the square
      const { top, left } = this.getImagePositioning(newWidth, newHeight, this.size, this.size)
      return { width: newWidth, height: newHeight, top, left }
    },
    imageStyles() {
      // get transform adjustment if rotated
      const orientationTransform = this.media.orientation && this.media.orientation > 1 ?
        getOrientationTransform(this.media.orientation) : ''
      const allStyles = this.isImageLoaded ? {
        'max-width': 'none',
        width: this.imageCssPropertyValues.width,
        height: this.imageCssPropertyValues.height,
        top: this.imageCssPropertyValues.top,
        left: this.imageCssPropertyValues.left
      } : {
        opacity: 0
      }
      return this.getStyleString(allStyles) + orientationTransform
    },
    itemStyles() {
      return this.getStyleString({ width: this.size, height: this.size })
    },
    imageSrc() {
      if (!this.isImage) {
        return this.media.thumbnailUrl // video
      } else if (this.onlyUseSrc || this.media.src) {
        // this can be anything that is valid for img src attribute.
        // initially added to pass the results of the FileReader
        return this.media.src
      } else if (this.media.imageId) {
        // src should be availble from FileReader, but older browsers don't support FileReader,
        // so using temp imaage as a backup.
        const baseURL = `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}`
        return `${baseURL}/media/temp/${this.media.imageId}.${this.media.imageType}`
      }
      return ''
    }
  },
  methods: {
    onImageLoad(e) {
      if (this.isImage) {
        this.width = this.media.width || e.target.width
        this.height = this.media.height || e.target.height
      } else {
        this.width = this.media.thumbnailWidth
        this.height = this.media.thumbnailHeight
      }
      this.isImageLoaded = true
    }
  }
}
</script>

<style lang="scss" src="./media-thumb.scss"></style>
